import dayjs from 'dayjs'
import z from 'zod'

const zSession = z.object({
    accessToken: z.string(),
    accessTokenExpiresAt: z.coerce.date(),
    // Refresh token info parsed as it is returned by the server, even if it is
    // never used on the client
    refreshToken: z.string(),
    refreshTokenExpiresAt: z.coerce.date(),
    self: z.object({
        id: z.string(),
        // `StaffAccess` row id — what the staff-access routes address,
        // and how the page knows which row is the signed-in person.
        accessId: z.string(),
        name: z.string(),
        email: z.string(),
        role: z.string(),
        // Advisory only — used to decide what to show. Every request
        // is authorised again by Habitat Admin.
        permissions: z.array(z.string()),
    }),
})

export type Session = z.infer<typeof zSession>

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export function validateSession(session: any): Session | null {
    const { data, error } = zSession.safeParse(session)

    if (error) {
        console.error(error)
        return null
    }

    const now = dayjs().toDate()

    if (data.accessTokenExpiresAt < now) {
        return null
    }

    return data
}

export function logout() {
    localStorage.removeItem('session')
    // Reload needed here as a top-level reload in App.tsx using useEffect on
    // session causes an infinite loop, unable to render the LoginPage and allow
    // session to be set
    location.reload()
}
